/**
 * Shared Swiper library + module registration for global4.js.
 * Scoped slider components should import Swiper from here instead of
 * 'swiper' directly, so modules are registered once in one place.
 * Also exposes window.Swiper so one-off inline <script> slider configs
 * (declared directly in page markup) can initialize their own instances
 * without each needing a separate vendor script tag.
 */
import Swiper from 'swiper';
import { A11y, FreeMode, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper/modules';

Swiper.use([A11y, FreeMode, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar]);

// Expose globally
if (typeof window !== 'undefined') {
  window.Swiper = Swiper;
}

// Set --swiper-slide-height from a slider's data-height attribute (see _swiper-elements.scss)
document.querySelectorAll('.swiper[data-height]').forEach(el => {
  el.style.setProperty('--swiper-slide-height', `${el.dataset.height}px`);
});

// Export so other modules can use
export default Swiper;
